export default __webpack_public_path__ + "static/media/Advanced-Care-Planning-1.7bd4c7cf.jpg";